// extracted by mini-css-extract-plugin
export default {"devices-table-header":"Devices_devices-table-header__ANzp4","devices-table":"Devices_devices-table__GCmvF"};